module.exports = __webpack_public_path__ + "8a5356e9/img/comments-icon.fdec7fdb.svg";